/**
 * Load in dust and languagepack templates.
 * Returns an instance of a loader, passing in an in-memory languagePack cache and dust/languagepack urls.
 * @deprecated
 */

'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _createLoader = require('./createLoader');

var _createLoader2 = _interopRequireDefault(_createLoader);

// the constants used to figure out where to load things from
var dataTemplatePath = document && document.body && document.body.getAttribute('data-template-path') || '';
var scriptPath = dataTemplatePath.replace('%s', 'dust-templates');
var languagePackPath = scriptPath.replace('dust-templates', 'languagepack').replace('.js', '.json');

// the cache for the languagePacks
var languagePackCache = {};

var newLoaderInstance = _createLoader2['default'](languagePackCache, scriptPath, languagePackPath);

exports['default'] = newLoaderInstance;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/forklifter/dist/loader.js
// module id = 192
// module chunks = 0 1 2 4 5 6